import { DropdownGroupRecord } from "./display/dropdown/DropdownGroupRecord";
import { DropdownOptionRecord } from "./display/dropdown/DropdownOptionRecord";
import { InspectorConstraintRecord } from "./display/inspector/InspectorConstraintRecord";
import { InspectorConstraintResolutionRecord } from "./display/inspector/InspectorConstraintResolutionRecord";
import { InspectorDependencyRecord } from "./display/inspector/InspectorDependencyRecord";
import { InspectorItemRecord } from "./display/inspector/InspectorItemRecord";
import { InspectorMarkerRecord } from "./display/inspector/InspectorMarkerRecord";
import { InspectorReferenceRecord } from "./display/inspector/InspectorReferenceRecord";
import { InspectorRelationshipItemTypeRecord } from "./display/inspector/InspectorRelationshipItemTypeRecord";
import { InspectorRelationshipRecord } from "./display/inspector/InspectorRelationshipRecord";
import { InspectorSyncItemPropertyChangeRecord } from "./display/inspector/InspectorSyncItemPropertyChangeRecord";
import { InspectorSyncItemRecord } from "./display/inspector/InspectorSyncItemRecord";
import { InspectorSyncItemRelationshipChangeRecord } from "./display/inspector/InspectorSyncItemRelationshipChangeRecord";
import { InspectorSyncItemTagChangeRecord } from "./display/inspector/InspectorSyncItemTagChangeRecord";
import { InspectorTypeRecord } from "./display/inspector/InspectorTypeRecord";
import { ItemCardDisplayRecord } from "./display/itemCard/ItemCardDisplayRecord";
import { ItemCardListDisplayRecord } from "./display/itemCard/ItemCardListDisplayRecord";
import { MenuItemRecord } from "./display/menu/MenuItemRecord";
import { PopoverMenuGroupRecord } from "./display/menu/PopoverMenuGroupRecord";
import { PopoverMenuItemRecord } from "./display/menu/PopoverMenuItemRecord";
import { MindmapConnectorDisplayRecord } from "./display/mindmapView/MindmapConnectorDisplayRecord";
import { MindmapDisplayRecord } from "./display/mindmapView/MindmapDisplayRecord";
import { MindmapListItem } from "./display/mindmapView/MindmapListItem";
import { MindmapNodeDisplayRecord } from "./display/mindmapView/MindmapNodeDisplayRecord";
import { NarrativeCardDisplayRecord } from "./display/narrativeView/NarrativeCardDisplayRecord";
import { NarrativeDisplayRecord } from "./display/narrativeView/NarrativeDisplayRecord";
import { NarrativeDropPositionRecord } from "./display/narrativeView/NarrativeDropPositionRecord";
import { NotificationWarningRecord } from "./display/notifications/NotificationWarningRecord";
import { SuggestionDisplayRecord } from "./display/notifications/SuggestionDisplayRecord";
import { SuggestionGroupDisplayRecord } from "./display/notifications/SuggestionGroupDisplayRecord";
import { RelationshipColumnDisplayRecord } from "./display/relationshipView/RelationshipColumnDisplayRecord";
import { RelationshipColumnGroupDisplayRecord } from "./display/relationshipView/RelationshipColumnGroupDisplayRecord";
import { RelationshipEventColumnDataDisplayRecord } from "./display/relationshipView/RelationshipEventColumnDataDisplayRecord";
import { RelationshipItemDisplayRecord } from "./display/relationshipView/RelationshipItemDisplayRecord";
import { RelationshipViewDisplayRecord } from "./display/relationshipView/RelationshipViewDisplayRecord";
import { ScrollPositionRecord } from "./display/scroll/ScrollPositionRecord";
import { SearchResultRecord } from "./display/search/SearchResultRecord";
import { AvatarDisplayRecord } from "./display/shared/AvatarDisplayRecord";
import { ConstraintWarningRecord } from "./display/shared/ConstraintWarningRecord";
import { DateDisplayRecord } from "./display/shared/DateDisplayRecord";
import { EntityDisplayValues } from "./display/shared/EntityDisplayValues";
import { IdentifierDisplayListOfTypeRecord } from "./display/shared/IdentifierDisplayListOfTypeRecord";
import { IdentifierDisplayRecord } from "./display/shared/IdentifierDisplayRecord";
import { ItemDatesRecord } from "./display/shared/ItemDatesRecord";
import { ItemDisplayRecord } from "./display/shared/ItemDisplayRecord";
import { ItemTypeDisplayValues } from "./display/shared/ItemTypeDisplayValues";
import { TimespanDisplayRecord } from "./display/shared/TimespanDisplayRecord";
import { ValidatedConstraintRecord } from "./display/shared/ValidatedConstraintRecord";
import { ValidatedDependencyRecord } from "./display/shared/ValidatedDependencyRecord";
import { SubwayDisplayRecord } from "./display/subwayView/SubwayDisplayRecord";
import { SubwayNodeDisplayRecord } from "./display/subwayView/SubwayNodeDisplayRecord";
import { SubwayThreadDisplayRecord } from "./display/subwayView/SubwayThreadDisplayRecord";
import { SubwayTickDisplayRecord } from "./display/subwayView/SubwayTickDisplayRecord";
import { TableAvailableColumnRecord } from "./display/tableView/TableAvailableColumnRecord";
import { TableCellGroupRecord } from "./display/tableView/TableCellGroupRecord";
import { TableCellPositionRecord } from "./display/tableView/TableCellPositionRecord";
import { TableCellRecord } from "./display/tableView/TableCellRecord";
import { TableCellSelectionRecord } from "./display/tableView/TableCellSelectionRecord";
import { TableColumnRecord } from "./display/tableView/TableColumnRecord";
import { TablePastedDataRecord } from "./display/tableView/TablePastedDataRecord";
import { TablePasteResultRecord } from "./display/tableView/TablePasteResultRecord";
import { TableRecord } from "./display/tableView/TableRecord";
import { TableRowRecord } from "./display/tableView/TableRowRecord";
import { TextMetricsRecord } from "./display/textMetrics/TextMetricsRecord";
import { TextSizeRecord } from "./display/textMetrics/TextSizeRecord";
import { LocalUndoMomentRecord } from "./display/textUndo/LocalUndoMomentRecord";
import { LocalUndoStackRecord } from "./display/textUndo/LocalUndoStackRecord";
import { AnniversaryDisplayRecord } from "./display/timelineView/AnniversaryDisplayRecord";
import { CalendarMarkerDisplayRecord } from "./display/timelineView/CalendarMarkerDisplayRecord";
import { ContextEventDotRecord } from "./display/timelineView/ContextEventDotRecord";
import { ContextScrollPositionRecord } from "./display/timelineView/ContextScrollPositionRecord";
import { DateDisplayTickRecord } from "./display/timelineView/DateDisplayTickRecord";
import { DateTickIntervalRecord } from "./display/timelineView/DateTickIntervalRecord";
import { TimelineDisplayRecord } from "./display/timelineView/TimelineDisplayRecord";
import { TimelineHeaderDisplayTicksRecord } from "./display/timelineView/TimelineHeaderDisplayTicksRecord";
import { TimelineViewEventPositionRecord } from "./display/timelineView/TimelineViewEventPositionRecord";
import { TimelineViewGroupRecord } from "./display/timelineView/TimelineViewGroupRecord";
import { TreeViewItemRecord } from "./display/treeView/TreeViewItemRecord";
import { TutorialDisplayRecord } from "./display/tutorial/TutorialDisplayRecord";
import { TutorialGroupDisplayRecord } from "./display/tutorial/TutorialGroupDisplayRecord";
import { TutorialStepDisplayRecord } from "./display/tutorial/TutorialStepDisplayRecord";
import { TutorialTipDisplayRecord } from "./display/tutorial/TutorialTipDisplayRecord";
import { SplitConstraintsRecord } from "./display/viewLayout/SplitConstraintsRecord";
import { ViewDisplayRecord } from "./display/viewLayout/ViewDisplayRecord";
import { ViewLayoutDisplayRecord } from "./display/viewLayout/ViewLayoutDisplayRecord";
import { FlatRectRecord } from "./helper/FlatRectRecord";
import { IdByTypeReferenceList } from "./helper/IdByTypeReferenceList";
import { IdReferenceList } from "./helper/IdReferenceList";
import { InsetRecord } from "./helper/InsetRecord";
import { LineRecord } from "./helper/LineRecord";
import { ListOptionRecord } from "./helper/ListOptionRecord";
import { PointRecord } from "./helper/PointRecord";
import { RangeRecord } from "./helper/RangeRecord";
import { RectRecord } from "./helper/RectRecord";
import { SizeRecord } from "./helper/SizeRecord";
import { TextSelectionRecord } from "./helper/TextSelectionRecord";
import { AppStateRecord } from "./model/appState/AppStateRecord";
import { MindmapViewOptionsRecord } from "./model/appState/MindmapViewOptionsRecord";
import { MobileViewRecord } from "./model/appState/MobileViewRecord";
import { OpenViewsRecord } from "./model/appState/OpenViewsRecord";
import { OutlineViewOptionsRecord } from "./model/appState/OutlineViewOptionsRecord";
import { RelationshipViewOptionsRecord } from "./model/appState/RelationshipViewOptionsRecord";
import { SubwayViewOptionsRecord } from "./model/appState/SubwayViewOptionsRecord";
import { SuggestionGroupRecord } from "./model/appState/SuggestionGroupRecord";
import { SuggestionRecord } from "./model/appState/SuggestionRecord";
import { TableViewColumnRecord } from "./model/appState/TableViewColumnRecord";
import { TimelineViewOptionsRecord } from "./model/appState/TimelineViewOptionsRecord";
import { ViewLayoutRecord } from "./model/appState/ViewLayoutRecord";
import { ViewRecord } from "./model/appState/ViewRecord";
import { AutoUpdatesRecord } from "./model/autoUpdates/AutoUpdatesRecord";
import { AttachmentRecord } from "./model/data/AttachmentRecord";
import { BoolFilterPartRecord } from "./model/data/BoolFilterPartRecord";
import { CalendarMarkerRecord } from "./model/data/CalendarMarkerRecord";
import { ConstraintRecord } from "./model/data/ConstraintRecord";
import { DateRecord } from "./model/data/DateRecord";
import { DependencyRecord } from "./model/data/DependencyRecord";
import { FilterRecord } from "./model/data/FilterRecord";
import { ItemRecord } from "./model/data/ItemRecord";
import { ListFilterPartRecord } from "./model/data/ListFilterPartRecord";
import { MindmapNodeRecord } from "./model/data/MindmapNodeRecord";
import { MindmapRecord } from "./model/data/MindmapRecord";
import { NarrativeFilterPartRecord } from "./model/data/NarrativeFilterPartRecord";
import { RangeFilterPartRecord } from "./model/data/RangeFilterPartRecord";
import { RelationshipRecord } from "./model/data/RelationshipRecord";
import { SuperAndChildrenRecord } from "./model/data/SuperAndChildrenRecord";
import { TimelineDataRecord } from "./model/data/TimelineDataRecord";
import { TimelineRangeRecord } from "./model/data/TimelineRangeRecord";
import { TimespanRecord } from "./model/data/TimespanRecord";
import { TreeRecord } from "./model/data/TreeRecord";
import { CalendarRecord } from "./model/definitions/CalendarRecord";
import { ColorRecord } from "./model/definitions/ColorRecord";
import { EraRecord } from "./model/definitions/EraRecord";
import { ItemCardViewSettingsRecord } from "./model/definitions/ItemCardViewSettingsRecord";
import { MindmapViewSettingsRecord } from "./model/definitions/MindmapViewSettingsRecord";
import { MonthRecord } from "./model/definitions/MonthRecord";
import { NarrativeLabelRecord } from "./model/definitions/NarrativeLabelRecord";
import { NarrativeSettingsRecord } from "./model/definitions/NarrativeSettingsRecord";
import { NarrativeViewSettingsRecord } from "./model/definitions/NarrativeViewSettingsRecord";
import { PropertyRecord } from "./model/definitions/PropertyRecord";
import { ReferenceRecord } from "./model/definitions/ReferenceRecord";
import { RelationshipViewSettingsRecord } from "./model/definitions/RelationshipViewSettingsRecord";
import { SubwayViewSettingsRecord } from "./model/definitions/SubwayViewSettingsRecord";
import { TimelineDefinitionsRecord } from "./model/definitions/TimelineDefinitionsRecord";
import { TimelineViewSettingsRecord } from "./model/definitions/TimelineViewSettingsRecord";
import { TypeRecord } from "./model/definitions/TypeRecord";
import { WeekdayRecord } from "./model/definitions/WeekdayRecord";
import { DisplayCacheRecord } from "./model/display/DisplayCacheRecord";
import { ViewCardSizesRecord } from "./model/display/ViewCardSizesRecord";
import { FileConflictStateRecord } from "./model/fileConflicts/FileConflictStateRecord";
import { FileConflictVersionRecord } from "./model/fileConflicts/FileConflictVersionRecord";
import { MobileScreenRecord } from "./model/mobileScreen/MobileScreenRecord";
import { PreferencesRecord } from "./model/preferences/PreferencesRecord";
import { SyncEntityFolderSettingsRecord } from "./model/sync/SyncEntityFolderSettingsRecord";
import { SyncFieldSettingsRecord } from "./model/sync/SyncFieldSettingsRecord";
import { SyncFolderLevelSettingsRecord } from "./model/sync/SyncFolderLevelSettingsRecord";
import { SyncSettingsRecord } from "./model/sync/SyncSettingsRecord";
import { TimelineSyncRecord } from "./model/sync/TimelineSyncRecord";
import { TutorialRecord } from "./model/tutorial/TutorialRecord";
import { UINotificationActionRecord } from "./model/uiState/UINotificationActionRecord";
import { UINotificationRecord } from "./model/uiState/UINotificationRecord";
import { UIStateRecord } from "./model/uiState/UIStateRecord";
import { PrintImageRecord } from "./printing/PrintImageRecord";
import { PrintingTableCellRecord } from "./printing/printingTableCellRecord";
import { StandardDataRecord } from "./standardFormat/StandardDataRecord";
import { StandardDefinitionRecord } from "./standardFormat/StandardDefinitionRecord";
import { StandardItemRecord } from "./standardFormat/StandardItemRecord";
import { StandardPropertyRecord } from "./standardFormat/StandardPropertyRecord";
import { StandardRelationshipRecord } from "./standardFormat/StandardRelationshipRecord";
import { StandardRelationshipTypeRecord } from "./standardFormat/StandardRelationshipTypeRecord";
import { StandardTimelineRecord } from "./standardFormat/StandardTimelineRecord";
import { StandardTypeRecord } from "./standardFormat/StandardTypeRecord";
import { SyncConflictRecord } from "./sync/SyncConflictRecord";
import { SyncCustomFieldOptionRecord } from "./sync/SyncCustomFieldOptionRecord";
import { SyncCustomFieldRecord } from "./sync/SyncCustomFieldRecord";
import { SyncDocumentRecord } from "./sync/SyncDocumentRecord";
import { SyncRepresentationRecord } from "./sync/SyncRepresentationRecord";
import { SyncStatusRecord } from "./sync/SyncStatusRecord";
import { SyncUpdateCollectionRecord } from "./sync/SyncUpdateCollectionRecord";
import { SyncUpdatePropertyRecord } from "./sync/SyncUpdatePropertyRecord";
import { SyncUpdateRecord } from "./sync/SyncUpdateRecord";
import { SyncUpdateRelationshipRecord } from "./sync/SyncUpdateRelationshipRecord";
import { SyncUpdateTagRecord } from "./sync/SyncUpdateTagRecord";
import { TemplateDetailsRecord } from "./TemplateDetailsRecord";
import { TimelineRecord } from "./TimelineRecord";
import { FileRecord } from "./welcome/FileRecord";
import { WelcomeScreenRecord } from "./welcome/WelcomeScreenRecord";
import { WelcomeTemplateRecord } from "./welcome/WelcomeTemplateRecord";

export default {
  // Helper Records
  SizeRecord,
  InsetRecord,
  PointRecord,
  RangeRecord,
  LineRecord,
  ListOptionRecord,
  RectRecord,
  FlatRectRecord,
  // Model Records
  TimespanRecord,
  DateRecord,
  ItemRecord,
  MindmapRecord,
  MindmapNodeRecord,
  TreeRecord,
  PropertyRecord,
  ReferenceRecord,
  TypeRecord,
  EraRecord,
  MonthRecord,
  WeekdayRecord,
  CalendarRecord,
  DateTickIntervalRecord,
  ColorRecord,
  RelationshipRecord,
  DependencyRecord,
  ValidatedDependencyRecord,
  ConstraintRecord,
  ValidatedConstraintRecord,
  ConstraintWarningRecord,
  CalendarMarkerRecord,
  TimelineRangeRecord,
  SuperAndChildrenRecord,
  TimelineDataRecord,
  TimelineDefinitionsRecord,
  TimelineRecord,
  IdReferenceList,
  IdByTypeReferenceList,
  AttachmentRecord,

  TimelineViewSettingsRecord,
  NarrativeViewSettingsRecord,
  NarrativeSettingsRecord,
  NarrativeLabelRecord,
  RelationshipViewSettingsRecord,
  MindmapViewSettingsRecord,
  SubwayViewSettingsRecord,
  ItemCardViewSettingsRecord,

  // Sync Records
  SyncFieldSettingsRecord,
  SyncEntityFolderSettingsRecord,
  SyncFolderLevelSettingsRecord,
  SyncSettingsRecord,
  SyncCustomFieldRecord,
  SyncCustomFieldOptionRecord,
  SyncRepresentationRecord,
  TimelineSyncRecord,
  SyncDocumentRecord,
  SyncUpdateRecord,
  SyncUpdatePropertyRecord,
  SyncUpdateTagRecord,
  SyncUpdateRelationshipRecord,
  SyncConflictRecord,
  SyncUpdateCollectionRecord,
  SyncStatusRecord,

  // Filter Records
  ListFilterPartRecord,
  RangeFilterPartRecord,
  NarrativeFilterPartRecord,
  BoolFilterPartRecord,
  FilterRecord,

  // AppState Records
  AppStateRecord,
  SuggestionRecord,
  SuggestionGroupRecord,
  SuggestionDisplayRecord,
  SuggestionGroupDisplayRecord,
  OpenViewsRecord,
  ViewLayoutRecord,
  ViewRecord,
  MobileViewRecord,
  RelationshipViewOptionsRecord,
  TimelineViewOptionsRecord,
  MindmapViewOptionsRecord,
  OutlineViewOptionsRecord,
  TableViewColumnRecord,
  SubwayViewOptionsRecord,

  // UiState Records
  UIStateRecord,
  UINotificationRecord,
  UINotificationActionRecord,

  // Preference Records
  PreferencesRecord,
  AutoUpdatesRecord,

  // Redux Display Cache
  DisplayCacheRecord,
  ViewCardSizesRecord,
  MobileScreenRecord,

  // Display Records
  IdentifierDisplayListOfTypeRecord,
  IdentifierDisplayRecord,
  ItemTypeDisplayValues,
  EntityDisplayValues,
  TextMetricsRecord,
  TextSizeRecord,
  AvatarDisplayRecord,
  ItemDatesRecord,
  ItemDisplayRecord,
  CalendarMarkerDisplayRecord,
  AnniversaryDisplayRecord,
  ContextEventDotRecord,
  ContextScrollPositionRecord,
  DateDisplayTickRecord,
  TimelineHeaderDisplayTicksRecord,
  TimelineViewEventPositionRecord,
  TimelineDisplayRecord,
  TimelineViewGroupRecord,

  MindmapNodeDisplayRecord,
  MindmapConnectorDisplayRecord,
  MindmapDisplayRecord,
  MindmapListItem,

  SubwayNodeDisplayRecord,
  SubwayThreadDisplayRecord,
  SubwayTickDisplayRecord,
  SubwayDisplayRecord,

  NarrativeCardDisplayRecord,
  NarrativeDisplayRecord,
  NarrativeDropPositionRecord,

  ItemCardDisplayRecord,
  ItemCardListDisplayRecord,

  RelationshipEventColumnDataDisplayRecord,
  RelationshipItemDisplayRecord,
  RelationshipColumnDisplayRecord,
  RelationshipColumnGroupDisplayRecord,
  RelationshipViewDisplayRecord,

  TableCellPositionRecord,
  TableCellGroupRecord,
  TableCellSelectionRecord,
  TableCellRecord,
  TableRowRecord,
  TableAvailableColumnRecord,
  TableColumnRecord,
  TableRecord,
  TablePasteResultRecord,
  TablePastedDataRecord,

  ViewDisplayRecord,
  ViewLayoutDisplayRecord,
  SplitConstraintsRecord,

  InspectorReferenceRecord,
  InspectorTypeRecord,
  DateDisplayRecord,
  TimespanDisplayRecord,
  InspectorItemRecord,
  InspectorMarkerRecord,
  InspectorSyncItemPropertyChangeRecord,
  InspectorSyncItemRelationshipChangeRecord,
  InspectorSyncItemTagChangeRecord,
  InspectorSyncItemRecord,
  InspectorRelationshipRecord,
  InspectorRelationshipItemTypeRecord,
  InspectorDependencyRecord,
  InspectorConstraintRecord,
  InspectorConstraintResolutionRecord,
  DropdownOptionRecord,
  DropdownGroupRecord,
  LocalUndoStackRecord,
  LocalUndoMomentRecord,
  TextSelectionRecord,

  MenuItemRecord,

  PopoverMenuItemRecord,
  PopoverMenuGroupRecord,

  NotificationWarningRecord,

  SearchResultRecord,
  TreeViewItemRecord,

  WelcomeScreenRecord,
  FileRecord,
  WelcomeTemplateRecord,

  ScrollPositionRecord,
  //Printing
  PrintingTableCellRecord,
  PrintImageRecord,

  // Standard format
  StandardDataRecord,
  StandardDefinitionRecord,
  StandardItemRecord,
  StandardPropertyRecord,
  StandardRelationshipTypeRecord,
  StandardRelationshipRecord,
  StandardTimelineRecord,
  StandardTypeRecord,

  // Template Details
  TemplateDetailsRecord,

  // Tutorial Stuff
  TutorialDisplayRecord,
  TutorialGroupDisplayRecord,
  TutorialTipDisplayRecord,
  TutorialStepDisplayRecord,
  TutorialRecord,

  // File Conflicts
  FileConflictVersionRecord,
  FileConflictStateRecord
};
